import React, { useState } from 'react'
import Form from '../system/forms/form'
import Fieldset from '../system/forms/fieldset'
import FormControl from '../system/forms/form-control'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import ContactFormActions from './contact-form-actions'
import {
  ValidatedInput,
  ValidatedTextarea,
  ValidatedPhoneNumber
} from '../system/forms/validated-input'
import NamePrefixSelect, { NameFormGroup } from './name-prefix-select'

const SUBMIT_TICKETING_FORM = gql`
  mutation SubmitTicketingForm($input: TicketingContactFormInput!) {
    submitTicketingContactForm(input: $input) {
      success
      error
    }
  }
`

const TicketingForm = () => {
  const [values, setValues] = useState({
    namePrefix: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    relatedEvent: '',
    message: ''
  })
  const [submit, { data, loading, error, called }] = useMutation(SUBMIT_TICKETING_FORM)

  const handleChange = (event: any) => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    setValues({
      ...values,
      [name]: value
    })
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    submit({
      variables: {
        input: values
      }
    })
  }

  return (
    <Form onSubmit={handleSubmit}>
      {({ isValid }: { isValid: boolean }) => (
        <>
          <Fieldset
            legendTitle="Contact Us"
            legendDescription="Have a question? We'll do our best to assist you."
            disabled={called && !error}
          >
            <NameFormGroup>
              <FormControl>
                <label htmlFor="namePrefix">Prefix</label>
                <NamePrefixSelect
                  name="namePrefix"
                  id="namePrefix"
                  value={values.namePrefix}
                  onChange={handleChange}
                  required
                />
              </FormControl>

              <FormControl>
                <label htmlFor="firstName">First Name</label>
                <ValidatedInput
                  type="text"
                  name="firstName"
                  id="firstName"
                  value={values.firstName}
                  onChange={handleChange}
                  required
                />
              </FormControl>

              <FormControl>
                <label htmlFor="lastName">Last Name</label>
                <ValidatedInput
                  type="text"
                  name="lastName"
                  id="lastName"
                  value={values.lastName}
                  onChange={handleChange}
                  required
                />
              </FormControl>
            </NameFormGroup>

            <FormControl>
              <label htmlFor="email">Email</label>
              <ValidatedInput
                type="email"
                name="email"
                id="email"
                value={values.email}
                onChange={handleChange}
                required
              />
            </FormControl>

            <FormControl>
              <label htmlFor="phoneNumber">Phone Number</label>
              <ValidatedPhoneNumber
                name="phoneNumber"
                id="phoneNumber"
                value={values.phoneNumber}
                onValueChange={value => setValues({ ...values, phoneNumber: value.formattedValue })}
                required
              />
            </FormControl>

            <FormControl>
              <label htmlFor="relatedEvent">What event is this regarding?</label>
              <ValidatedInput
                type="text"
                name="relatedEvent"
                id="relatedEvent"
                value={values.relatedEvent}
                onChange={handleChange}
                required
              />
            </FormControl>

            <FormControl>
              <label htmlFor="message">Message</label>
              <ValidatedTextarea
                name="message"
                id="message"
                value={values.message}
                onChange={handleChange}
                required
              />
            </FormControl>
          </Fieldset>

          <ContactFormActions
            isValid={isValid}
            success={data && data.submitTicketingContactForm.success}
            loading={loading}
            error={error}
            called={called}
          />
        </>
      )}
    </Form>
  )
}

export default TicketingForm
